import type { Squad } from '../../../types';
import { computeTotalClassesFromSchedule } from '../../../shared/billing/squadInvoiceRollup';

type PortfolioSquad = Squad & Record<string, any>;

export function isActivePortfolioSquad(squad: PortfolioSquad): boolean {
  return !['archived', 'canceled', 'cancelled'].includes(String(squad.status || '').toLowerCase());
}

export function isSingleDaySquad(squad: PortfolioSquad): boolean {
  return squad.scheduleKind === 'single_day' || Boolean(squad.schedule?.mainDate);
}

export function countsTowardRecurringSquadTarget(squad: PortfolioSquad): boolean {
  return isActivePortfolioSquad(squad) && !isSingleDaySquad(squad);
}

export function paidClassDaysForSquad(
  squad: PortfolioSquad,
  partnerDefaultPriceCents: number,
): number {
  if (!isActivePortfolioSquad(squad)) return 0;
  const mode = String(squad.paymentMode || 'stripe');
  const explicitRaw = mode === 'school_flat_fee'
    ? squad.flatFeePerClassCents ?? squad.priceCents
    : squad.tuitionPerStudentPerClassCents ?? squad.priceCents;
  const explicitPrice = Number(explicitRaw);
  const isDemo = isSingleDaySquad(squad) && squad.singleDayType === 'demo';
  // A demo without its own positive price is free. Partner program defaults
  // must not silently turn it into a paid calendar day.
  const effectivePrice = Number.isFinite(explicitPrice)
    ? explicitPrice
    : isDemo
      ? 0
      : partnerDefaultPriceCents;
  if (!Number.isFinite(effectivePrice) || effectivePrice <= 0) return 0;
  if (isSingleDaySquad(squad)) return 1;
  const storedTotal = Number(squad.totalClasses);
  const events = Number.isFinite(storedTotal) && storedTotal > 0
    ? Math.round(storedTotal)
    : (computeTotalClassesFromSchedule(squad.schedule) || 0);
  return Math.max(0, events);
}
